<template>
  <UiText variant="subtitle-4">
    <slot />
  </UiText>
</template>

<script setup lang="ts">
import { UiText } from '~/ui';
</script>

<style scoped></style>
